import { render, staticRenderFns } from "./PredictionResult.vue?vue&type=template&id=231e0087&"
import script from "./PredictionResult.vue?vue&type=script&lang=js&"
export * from "./PredictionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports